import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './styles/theme';

// Distinguish non-production environments in the browser tab (title + favicon),
// so it's obvious at a glance which environment a tab is pointed at.
// REACT_APP_ENV_LABEL is only ever set on non-prod deployments - prod is untouched.
if (process.env.REACT_APP_ENV_LABEL) {
  document.title = `TailorHub (${process.env.REACT_APP_ENV_LABEL})`;

  const devIconHref = `${process.env.PUBLIC_URL || ''}/favicon-dev.svg`;
  document.querySelectorAll("link[rel~='icon']").forEach((link) => {
    link.setAttribute('href', devIconHref);
    link.setAttribute('type', 'image/svg+xml');
    link.removeAttribute('sizes');
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA installability (production only)
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/service-worker.js`).catch(() => {});
  });
}
